import InputField from 'components/InputField';
import { Fragment, useEffect, useState } from 'react';
import { getAttributes } from 'services/audience_management';
import Select from 'components/Select';
import { CustomerBase } from 'config';
import Body from './Body';

const AddCustomer = () => {
  const [chooseFile, set_choose_file] = useState(1);
  const [numberClickAnd, setNumberClickAnd] = useState([1]);
  const [Attributes, setAttributes] = useState([]);
  const [attributeValues, set_attributeValues] = useState({});
  const [selectProperties, setSelectProperties] = useState({});

  const [management, setManagement] = useState({});

  const [name_audience, set_name_audience] = useState('');
  const [description, set_description] = useState('');
  const [firebaseTopic, set_firebaseTopic] = useState('');
  const [status, set_status] = useState('');
  const [customize_type, set_customize_type] = useState('');

  useEffect(() => {
    async function freshData() {
      const value = await getAttributes();
      console.log(value.data.data);
      setAttributes(value.data.data);
    }
    freshData();
  }, []);

  return (
    <div className="container-fluid">
      <div className="bg-white card pt-5">
        <div className="card-header border-0 pt-6 pb-0">
          <div className="w-100 d-flex justify-content-between">
            <div className="card-title my-0">
              <h3 className="card-label">
                <b>THÊM TẬP KHÁCH HÀNG</b>{' '}
              </h3>
            </div>
          </div>
        </div>
        <div className="card-body py-3 d-flex flex-column min-h-100 gap-4">
          <div>
            <div className="row">
              <div className="col-sm">
                <InputField
                  label={'Tên tập khách hàng (*)'}
                  placeholder={'Tên tập khách hàng'}
                  style={'w-400px'}
                //   value={(item) => set_name_audience(item)}
                />
              </div>
              <div className="col-sm flex justify-end">
                <Select
                  label={'Loại tập khách hàng (*)'}
                  style={'w-400px'}
                  data={CustomerBase.type}
                  displayValue={'name'}
                  value={(item) => {
                    set_choose_file(item.id);
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <InputField
              label={'Mô tả (*)'}
              placeholder={'Nhập mô tả'}
              style={'w-full'}
              value={(item) => set_description(item)}
            />
          </div>
          {chooseFile == 1 ? (
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Tải file khách hàng (.csv, .xlsx, .xls)
              </label>
              <input
                className="block w-full text-lg text-gray-900 border border-gray-300 rounded-sm cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                type="file"
                accept=".csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                id="file"
              />
            </div>
          ) : (
            <div className="flex flex-col gap-3">
              <label>Danh sách thuộc tính lọc</label>
              {numberClickAnd.map((item, i) => (
                <Fragment key={i}>
                  <div className="border-1 gap-3" key={i}>
                    <Body />
                  </div>
                  {i != numberClickAnd.length - 1 && <span>AND</span>}
                </Fragment>
              ))}
            </div>
          )}
          <div>
            <div className="row">
              <div className="col-sm">
                <InputField
                  label={'Firebase topic id (*)'}
                  placeholder={'Nhập firebase topic'}
                  style={'w-400px'}
                  value={(item) => set_firebaseTopic(item)}
                />
              </div>
              <div className="col-sm flex justify-end">
                <Select
                  label={'customize_type (*)'}
                  style={'w-400px'}
                  data={CustomerBase.customize_type}
                  displayValue={'name'}
                  value={(item) => set_customize_type(item)}
                />
              </div>
              <div className="col-sm flex justify-end">
                <Select
                  label={'Trạng thái (*)'}
                  style={'w-400px'}
                  data={CustomerBase.status}
                  displayValue={'name'}
                  value={(item) => set_status(item)}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col-sm"></div>
              <div className="col-sm">
                <div className="d-flex justify-content-end gap-5">
                  <span className="btn btn-bg-secondary">Hủy</span>
                  <span
                    className="btn btn-primary"
                    onClick={() => {
                      //   OnSave();
                    }}
                  >
                    Lưu
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddCustomer;
